import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { Project } from '../common/constant';
import { formatDate } from '../common/datetime';
import Image from '../common/image';
import EventPriceRange from '../common/eventPriceRange';

const EventFormListingPreview = props => {
  const { values, translate, activeLanguage } = props;
  const {
    name, coverImageTempUrl, start, end, type
  } = values;

  const eventFormattedDate = `
    ${formatDate(start, activeLanguage)} - ${formatDate(end, activeLanguage)}
  `;

  const eventStatus = (
    <span className='event-status'>{translate('Coming Soon')}</span>
  );

  return (
    <Card as='div' className='preview-listing'>
      <div className='event-coverImage'>
        <Image
          alt='Event cover'
          src={
            coverImageTempUrl || Project.defaultCoverImage
          }
        />
      </div>

      <Card.Content>
        <Card.Meta>
          {eventStatus}
          <Icon name='calendar outline' />
          <div className='event-date'>{eventFormattedDate}</div>
        </Card.Meta>
        <Card.Header>{name}</Card.Header>
        <Card.Meta className='event-price'>
          <EventPriceRange eventType={type} />
        </Card.Meta>
      </Card.Content>
    </Card>
  );
};

export default withLocalize(EventFormListingPreview);



// WEBPACK FOOTER //
// ./src/components/forms/eventFormListingPreview.js